import {http} from "../_helpers";
import Service from "./Service";

class AiService extends Service {

    getRequestScore(id) {
        return http.get(`/ai/requests/${id}/score`);
    }

    recomputeScore(id) {
        return http.post(`/ai/requests/${id}/score/recompute`);
    }

    getScoreByPhone(phone) {
        return http.get(`/ai/score?phone=${encodeURIComponent(phone)}`);
    }

    getScoreHistory(phone, limit) {
        return http.get(this.makeOptionsUrl(`/ai/score/history`, {}, {phone, limit}));
    }

    recomputeScoreByPhone(phone) {
        return http.post(`/ai/score/recompute?phone=${encodeURIComponent(phone)}`);
    }

    getCallAnalysis(entryId) {
        return http.get(`/ai/calls/${entryId}/analysis`);
    }

    getReactivation(filter) {
        return http.get(this.makeOptionsUrl(`/ai/reactivation`, {}, filter));
    }

    getBudgetToday() {
        return http.get(`/ai/budget/today`);
    }
}

export default new AiService;
